import { BottomBanner } from './BottomBanner';  
export default BottomBanner;